import styled from "styled-components";
import NavBar from "../Componentes/NavBar"
import Content from "../Modulos/EquipCalib/Content";
import { useModal } from "../contexts/ModalContext";

const BodyWrapper = styled.div`
    width: 100%;
    flex: 1;
    background-color: #242d34;
    padding: 10px;
    box-sizing: border-box;
    overflow: hidden;
`

const EquipCalibracao = () => {

    const { openModal } = useModal();

    const abrirMenuLateral = () => {
        openModal("sidebarEquipCalibracao")
    }

    return (
        <>
            <NavBar goBackOnePage title="EQUIPAMENTOS CALIBRAÇÃO" setSideBar={abrirMenuLateral} />
            <BodyWrapper>
                <Content />
            </BodyWrapper>
        </>
    )
}

export default EquipCalibracao;